import React from "react";
import Typography from "@mui/material/Typography";
import Colors from "./Colors";

function TypographyComponentNormal({ onClick, sx, ...props }) {
  return (
    <Typography
      sx={{
        fontFamily: "IBM Plex Sans",
        fontWeight: 400,
        lineHeight: "24px",
        fontSize: { xs: "12px", md: "20px" },
        color: Colors.TypoNormal,
        ...sx,
      }}
      {...props}
      onClick={onClick}
    ></Typography>
  );
}

export default TypographyComponentNormal;
